module.exports = __webpack_public_path__ + "static/img/logo-transformation-alliance.429a81e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo-transformation-alliance.jpg
// module id = gix4
// module chunks = 1